export default "__VITE_PUBLIC_ASSET__69f12e2b__"